const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['common/components/UsersSearchSource'];